import { Dtos } from '#models';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class PssrSectionOrderService {
  private http = inject(HttpClient);
  changeOrder(newOrder: number, section: Dtos.TaskPlanSection): Observable<Partial<Dtos.PSSRSectionOrder>> {
    return this.http.put<Partial<Dtos.PSSRSectionOrder>>(
      `${environment.apiUrl}/pssrSectionOrder/switchOrder/${newOrder}`,
      {
        PSSRID: section.Responses[0].PSSRID,
        SectionDescription: section.Description,
        SectionID: section.ID,
      }
    );
  }
  bulkChangeOrder(batch: Dtos.PSSRSectionOrder[] = []) {
    return this.http.put(`${environment.apiUrl}/pssrSectionOrder/switchOrder`, batch);
  }
}
